module.exports = __webpack_public_path__ + "static/media/refer-a-friend.78293714.jpg";